import Widget from "./base.js";
import { getCookie, setCookie } from "tpm-utils";
import { NewsletterSignupForm } from "./newsletter-signup-form.js";

// Full-page modal that nags signed-out visitors to sign up for a newsletter.
// Placed on archive.php. Takes a `category` prop (same as NewsletterSignupBlock)
// and renders NewsletterSignupForm inside the modal, handing the category down.
//
// Dismissal: a "No thanks" button at the bottom sets a cookie with a 1-day
// expiry. On mount, if the cookie is present the modal renders nothing.
// While visible, body.scroll is frozen to prevent background scrolling.

const slugMatch = (a, b) => (a ?? "").replace(/[-_]/g, "-") === (b ?? "").replace(/[-_]/g, "-");

export class NewsletterSignupNag extends Widget {
	componentWillMount() {
		this.dismiss = this.dismiss.bind(this);
		 this.DISMISS_COOKIE = "tpm_newsletter_signup_nag_dismissed_" + this.props.category;
		if (getCookie(this.DISMISS_COOKIE)) {
			this.state.dismissed = true;
			return;
		}
	}

	componentDidMount() {
		if (this.state.dismissed) return;
		document.body.classList.add("freeze");
	}

	dismiss() {
		this.setState({ dismissed: true }, () => {
			setCookie(this.DISMISS_COOKIE, "1", 1  );
			document.body.classList.remove("freeze");
		});
	}

  listDescription(slug) {
		console.log(slug);
		if (slugMatch(slug, "morning_memo")) {
			return (
				<div>
					<div className="NewsletterSignupNag__Title">Morning Memo</div>
					<p>David Kurtz brings you the essential political roundup each weekday morning.</p>
					<p><b>Get Morning Memo for free in your inbox</b></p>
				</div>
			);
		}

		if (slugMatch(slug, "the_weekender")) {
			return (
				<div>
					<div className="NewsletterSignupNag__Title">The Weekender Newsletter</div>
					<p>Unpack the funny, surreal, and strange in U.S. politics and culture with Allegra Kirkland, Derick Dirmaier and the TPM team.</p>
				</div>
			);
		}

		if (slugMatch(slug, "the_franchise")) {
			return (
				<div>
					<div className="NewsletterSignupNag__Title">The Franchise Newsletter</div>
					<p>What you need to know about the assault on voting rights and democracy in America, brought to you
					weekly by TPM reporter Khaya Himmelman.</p>
				</div>
			);
		}

		if (slugMatch(slug, "the_brief")) {
			return (
				<div>
					<div className="NewsletterSignupNag__Title">The Brief</div>
					<p>John Light starts your day with some quick thoughts on key stories TPM will be following.</p>
					<p><b>Get The Brief for free in your inbox</b></p>
				</div>
			);
		}

		if (slugMatch(slug, "the_backchannel")) {
			if (this.props.membership && this.props.membership === "1")
				return (
					<div>
						<div className="NewsletterSignupNag__Title">The Backchannel Newsletter</div>

						<p>Josh Marshall's direct
						line for insight, analysis, and conversation. TPM members receive
						one must-read daily.</p>
					</div>
				);

			return (
				<div>
					<div className="NewsletterSignupNag__Title">The Backchannel Newsletter</div>
					<p>Josh Marshall's direct line for insight, analysis, and conversation. Non-members can subscribe to
					the free edition and receive one must-read from Josh weekly.</p>
				</div>
			);
		}

		return "";
	}

	renderContent() {
		if (this.state.dismissed) return null;

		return (
			<div className={`NewsletterSignupNag__Wrapper --${this.props.category}`}>
				<div className="NewsletterSignupNag__Inner">
          <img  className="NewsletterSignupNag__Img" src="https://talkingpointsmemo.com/wp-content/themes/tpm25/assets/images/logo/TPM-logo.svg?v=0" alt="TPM Logo" />
				  <div className="NewsletterSignupNag__Description">
            {this.listDescription(this.props.category)}
          </div>
					<NewsletterSignupForm category={this.props.category} cssclasses="--red"/>
					<div
						className="NewsletterSignupNag__Dismiss"
						onClick={this.dismiss}
					>
						No thanks
					</div>
				</div>
			</div>
		);
	}
}
